import TourNavigator from "./TourNavigator";

export default TourNavigator;
